module.exports = __webpack_public_path__ + "img/asset_result_right.5654e2df.png";